import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/bell-ring.vue
var s = {
	name: "DtIconBellRing",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--bell-ring"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Bell Ring",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M2.304.603a.5.5 0 0 1 .093.7A4.422 4.422 0 0 0 1.5 4a.5.5 0 0 1-1 0C.5 2.794.884 1.636 1.603.696a.5.5 0 0 1 .7-.093ZM9.7.6a.5.5 0 0 1 .7.1A5.5 5.5 0 0 1 11.5 4a.5.5 0 0 1-1 0 4.5 4.5 0 0 0-.9-2.7.5.5 0 0 1 .1-.7Zm-4.816 9.468a.5.5 0 0 1 .684.181.5.5 0 0 0 .865 0 .5.5 0 1 1 .865.502 1.5 1.5 0 0 1-2.595 0 .5.5 0 0 1 .181-.683ZM6 .5A3.5 3.5 0 0 0 2.5 4c0 1.676-.359 2.717-.689 3.323a2.968 2.968 0 0 1-.44.622c-.056.06-.1.099-.127.121l-.016.014A.5.5 0 0 0 1.5 9h9a.5.5 0 0 0 .283-.912l-.001-.001a1.507 1.507 0 0 1-.153-.142 2.97 2.97 0 0 1-.44-.622C9.859 6.717 9.5 5.676 9.5 4A3.5 3.5 0 0 0 6 .5Zm0 1A2.5 2.5 0 0 0 3.5 4c0 1.824-.391 3.033-.811 3.802L2.584 8h6.841a4.705 4.705 0 0 1-.114-.198C8.891 7.032 8.5 5.824 8.5 4A2.5 2.5 0 0 0 6 1.5Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=bell-ring.js.map